// Mount point for the bundle upsell banner under the policy type picker (#36375).
const BundleBanner = () => null;

export default BundleBanner;
